// src/components/NavBar.jsx
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import { Navbar, Nav, Button, Container } from 'react-bootstrap';
import logo from '../images/SanPancracio.png';
// import logo from '../images/DANLU_logo_transparent.png';
import '../css/navbar.css';

export default function NavBar() {
  /* ─── estado usuario & token ─── */
  const location = useLocation();
  const history = useHistory();
  const [user, setUser] = useState('Iniciar sesión');
  const [role, setRole] = useState('');

  /* ─── chequeo de token ─── */
  useEffect(() => {
    const usuarioLS = JSON.parse(localStorage.getItem('usuario'));
    setUser(usuarioLS || 'Iniciar sesión');

    const token = localStorage.getItem('token') || '';
    try {
      if (token) {
        const { usuario } = jwt_decode(token);
        setRole(usuario.role);
      }
    } catch {
      setRole('');
    }
  }, [location]);

  /* ─── logout ─── */
  const handleLogout = () => {
    ['token', 'id', 'usuario'].forEach((k) => localStorage.removeItem(k));
    setRole('');
    setUser('Iniciar sesión');
    history.push('/login');
  };

  /* ─── links visibles para ADMIN ─── */
  const adminLinks = [
    { label: 'Remitos',      to: '/Remitos' },
    { label: 'R. Campo',      to: '/Remitocs' },
    // { label: 'Viajes',       to: '/Comandas' },
    { label: 'Cajas',        to: '/Cajas' },
    { label: 'Movimientos',  to: '/Movimientos' },
    // { label: 'Rendiciones',  to: '/Viajes' },
    { label: 'Altas',        to: '/HomeAltas' },
    { label: 'Informes',     to: '/HomeImpresion' },
    { label: 'Acerca de',    to: '/AcercaDe' },
  ];

  return (
          <Container>
            <Navbar bg="white" expand="lg" sticky="top" className="shadow-sm py-1">
              {/* Container normal (no fluid) para que el navbar se limite al ancho estándar */}
          
                {/* Logo + nombre */}
                <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
                  <img src={logo} alt="DANLU" height={70} className="me-2" />
                  {/* <span className="fw-bold ">SAN PANCRACIO SRL</span> */}
                </Navbar.Brand>

                {/* Hamburguesa */}
                <Navbar.Toggle aria-controls="danlu-nav" />

                <Navbar.Collapse id="danlu-nav">
                  <Nav className="ms-auto">
                    {role.startsWith('ADMIN') &&
                      adminLinks.map(({ label, to }) => (
                        <Nav.Link as={Link} key={to} to={to} className="px-3">
                          {label}
                        </Nav.Link>
                      ))}
                  </Nav>

                  <Button
                    variant="outline-dark"
                    size="lg"
                    className="fw-bold px-5 py-2"
                    style={{ fontSize: '1.25rem' }}
                    onClick={handleLogout}
                  >
                    {user}
                  </Button>
                </Navbar.Collapse>
            </Navbar>
          </Container>
  );
}
